import { getRequest, postRequest } from '@bo-apis/axios';

const createBookmarkMenu = (payload) => {
  return postRequest({
    url: '/api/v1/system/menu/bookmark',
    data: { ...payload },
  });
};

const getBookmarkMenu = (skip = {}) => {
  return getRequest(
    {
      url: '/api/v1/system/menu/bookmark',
    },
    skip
  );
};

const getLnbMenuList = (skip = {}) => {
  return getRequest(
    {
      url: '/api/v1/system/menu/get-lnb-menu-list',
    },
    skip
  );
};

const getMenuList = ({ ...form }) => {
  return postRequest({
    url: '/api/v1/system/menu/get-menu-list',
    data: { ...form },
  });
};

const saveMenuGridData = (gridData) =>
  postRequest({
    url: '/api/v1/system/menu/save-menu-list',
    data: { ...gridData },
  });

const getMenuApiMappingList = (menuNumber) =>
  getRequest({
    url: `/api/v1/system/menu/${menuNumber}/get-menu-api-list`,
  });

const saveMenuApiMappingGridData = (gridData) =>
  postRequest({
    url: `/api/v1/system/menu/save-menu-api-list`,
    data: { ...gridData },
  });

const getMenuPageList = () => {
  return getRequest({
    url: '/api/v1/system/menu/get-menu-page-list',
  });
};

export default {
  createBookmarkMenu,
  getBookmarkMenu,
  getLnbMenuList,
  saveMenuGridData,
  getMenuList,
  getMenuApiMappingList,
  saveMenuApiMappingGridData,
  getMenuPageList,
};
